import {
  checkAuthsError,
  checkPeterwittToken,
  getSLT,
  handleAuthResponse,
  handleLogout,
  isLoggedIn,
} from '@sky-uk/ita-js-common-token-manager';

import logger from '../../services/logging/logging-service';
import { authActions } from '../../global-store/subjects/auth';

import { fetchTMApi, logoutCerebro } from './auth-api';

const JWTApplicationID = 'spw';

export const init = async () => {
  authActions.authStart();

  // User is not logged, PETERWITT token does not exist
  if (!checkPeterwittToken()) {
    handleLogout(); // Clean removing possible SLT+RTK
    authActions.authEnd(false);
    return;
  }

  // User is logged as PETERWITT here exists and also SLT + RTK (isLoggedIn())
  if (isLoggedIn()) {
    authActions.authEnd(true, getSLT());
    return;
  }

  // User is not logged (no SLT+RTK), PETERWITT exists, we try to get a new authorization token from TM
  try {
    const httpResponse = await fetchTMApi({
      method: 'POST',
      credentials: 'include',
      data: { application: JWTApplicationID, type: 'JWTC' },
    });
    const response = await httpResponse.json();

    // Failure
    if (!httpResponse.ok) {
      const error = checkAuthsError(httpResponse?.status, response?.code);
      throw new Error(error);
    }

    // Success
    const { isBlacklisted } = handleAuthResponse(response);
    if (isBlacklisted) {
      throw new Error('User in blacklist');
    } else {
      authActions.authEnd(true, getSLT());
    }
  } catch (error) {
    logger.error('[Auth] cannot get the tokens from TM - ', error);
    await logoutCerebro();
    handleLogout();
    authActions.authEnd(false);
  }
};
